<div class="select-container">
  <label class="select-label">{{ labelText }}</label>
  <div class="select">
    <select
      [disabled]="disabled"
      class="select-component"
      [(ngModel)]="model"
      (ngModelChange)="onChange($event)"
      [required]="required"
      [ngClass]="{ input__invalid: submitted && !model }"
    >
      <option class="option-text" value="" disabled selected>{{ placeholder }}</option>
      <option *ngFor="let option of options" [value]="option.value" class="option-text">
        {{ option.text }}
      </option>
    </select>
    <mat-icon>expand_more</mat-icon>
  </div>
  <label class="warning-label" *ngIf="submitted && !model && !labelWarningGenericText">
    Ingrese su {{ labelText }}
  </label>
  <label class="warning-label" *ngIf="submitted && !model && labelWarningGenericText">Seleccione una opcion</label>
</div>
